import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const baseText = 'What are the pros and cons of'

const prosAndConsTitle: Record<CreditCardProductCategory, string> = {
    [CreditCardProductCategory.BalanceTransfer]: `${baseText} balance transfer credit cards?`,
    [CreditCardProductCategory.BestCards]: `${baseText} credit cards?`,
    [CreditCardProductCategory.Cashback]: `${baseText} cashback credit cards?`,
    [CreditCardProductCategory.Combined]: `${baseText} balance transfer and purchase credit cards?`,
    [CreditCardProductCategory.PoorCredit]: `${baseText} credit cards for bad credit?`,
    [CreditCardProductCategory.Purchase]: `${baseText} 0% purchase credit cards?`,
    [CreditCardProductCategory.Rewards]: `${baseText} rewards credit cards?`,
    [CreditCardProductCategory.Travel]: `${baseText} travel credit cards?`,
}

export default prosAndConsTitle
